import { render, staticRenderFns } from "./TenantUserServerManager.vue?vue&type=template&id=53e21007&scoped=true&"
import script from "./TenantUserServerManager.vue?vue&type=script&lang=js&"
export * from "./TenantUserServerManager.vue?vue&type=script&lang=js&"
import style0 from "./TenantUserServerManager.vue?vue&type=style&index=0&id=53e21007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e21007",
  null
  
)

export default component.exports